import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from 'antd';
import styled, { withTheme } from 'styled-components';
import { useMediaQuery } from 'react-responsive';

const DrawerRPC = ({
	children,
	onClose,
	isOpen,
	title,
	position = 'right',
	closeable = true,
	width = 330
}) => {
	const isFullWidth = useMediaQuery({ query: '(max-width: 550px)' });
	const isExpandedWidth = useMediaQuery({ query: '(max-width: 900px)' });
	const drawerWidth = isFullWidth ? '100%' : isExpandedWidth ? '80vw' : width;
	return (
		<DrawerStyled
			title={title}
			placement={position}
			closable={closeable}
			onClose={onClose}
			visible={isOpen}
			width={drawerWidth}
		>
			{children}
		</DrawerStyled>
	);
};

const DrawerStyled = styled(Drawer)`
	&& {
		.ant-drawer-wrapper-body {
			background: ${({ theme: { sidebar } }) => sidebar.bg};
		}

		.ant-drawer-header {
			background: transparent;
			border-bottom-color: ${({ theme }) => theme.line};
		}

		.ant-drawer-title {
			color: ${({ theme }) => theme.grayMedium};
		}

		.ant-drawer-close {
			color: ${({ theme: { sidebar } }) => sidebar.closeIcon};
		}

		.ant-drawer-body {
			padding: 0 0 2rem 0;
		}
	}
`;

DrawerRPC.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	title: PropTypes.string.isRequired,
	position: PropTypes.string,
	closeable: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	isOpen: PropTypes.bool.isRequired
};

export default withTheme(DrawerRPC);
